import React from 'react';
const { getCurrentBrand } = require('../../config/brands');

/**
 * BrandLogo - Renders the correct logo for the current brand
 * @param {Object} props - Component props
 * @param {string} props.className - Optional CSS class
 * @param {Object} props.style - Optional inline styles
 * @param {string} props.alt - Optional alt text, defaults to brand name
 * @param {string} props.loading - Optional loading attribute ('eager', 'lazy')
 * @param {string} props.fetchpriority - Optional fetchpriority attribute ('high', 'low', 'auto')
 */
const BrandLogo = ({ className, style, alt, loading, fetchpriority }) => {
  const brand = getCurrentBrand();
  const brandId = process.env.REACT_APP_BRAND || 'ezseat';
  const altText = alt || `${brand.name} logo`;
  
  // Construct the correct path to the logo
  // This matches the path where the build script is copying the logo
  const logoPath = `/images/brands/${brandId}_logo.webp`;
  
  return (
    <img 
      src={logoPath} 
      alt={altText} 
      className={className} 
      style={style}
      loading={loading}
      fetchpriority={fetchpriority}
    />
  );
};

export default BrandLogo;